<template>
    <div class="space-y-8 md:space-y-12 container mx-auto px-3 pb-32 md:px-8">
        <slot></slot>
    </div>
</template>
